import { TeacherFrontPageTranslations } from './types';

export const deTranslations: TeacherFrontPageTranslations = {
    buttons: {
        createClass: "Neue Session erstellen",
        reviewClasses: "Vorherige Sessions ansehen"
    }
};